import { useEffect } from 'react';
import img1 from "../../images/AE-Insight-1.jpg";
import img2 from "../../images/AE-Insight-2.jpg";
import img3 from "../../images/AE-Insight-3.jpg";
import img4 from "../../images/AE-Insight-4.jpeg";
import img5 from "../../images/AE-img-8.jpeg";
import img6 from "../../images/AE-Insight-5.jpeg";
import Logo from "../../images/AE-Hero.svg";

const RecentPosts = () => {
    useEffect(() => {
        // Refresh AOS animations when component mounts
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.refresh();
        }
    }, []);

    const posts = [
        {
            id: 1,
            title: "KFC's Journey to 100% Renewable Energy",
            image: img1,
            date: "December 12",
            author: "Solar Expert",
            category: "Energy Savings",
            delay: "100",
            description: "We designed and installed a complete solar energy system for KFC, enabling the restaurant to run on clean, renewable power. The solution significantly reduces grid dependency and cuts energy costs — keeping the kitchen running efficiently while shrinking the carbon footprint."
        },
        {
            id: 2,
            title: "Building Society: Powering Modern Banking with Smart Lighting",
            image: img2,
            date: "July 17",
            author: "Business Solutions",
            category: "Commercial Wiring",
            delay: "200",
            description: "Our team carried out a full electrical wiring and lighting installation for this modern banking facility. From the vibrant service counters to the ambient ceiling fixtures, every circuit was carefully planned to deliver a bright, professional environment that enhances the customer experience."
        },
        {
            id: 3,
            title: "Sage Coffee Shop: Crafting the Perfect Ambience with Light",
            image: img3,
            date: "September 05",
            author: "Lighting Specialist",
            category: "Interior Lighting",
            delay: "300",
            description: "For Sage Coffee Shop, we installed a warm Edison-style pendant lighting system that transforms the industrial space into an inviting retreat. The carefully wired lighting grid creates the perfect atmosphere — drawing customers in and keeping them comfortable from the first sip to the last."
        },
        {
            id: 4,
            title: "Hungry Lion: Illuminating a Busy Commercial Hub",
            image: img4,
            date: "September 05",
            author: "Commercial Electrician",
            category: "Commercial Wiring",
            delay: "300",
            description: "We completed a comprehensive electrical wiring and lighting installation at this high-traffic Hungry Lion outlet. The bright, energy-efficient lighting enhances visibility and safety across the storefront and interior, ensuring a welcoming environment for the large volume of customers passing through daily."
        },
        {
            id: 5,
            title: "Hlane: Large-Scale Industrial Lighting Installation",
            image: img5,
            date: "September 05",
            author: "Industrial Electrician",
            category: "Industrial Lighting",
            delay: "300",
            description: "We executed a large-scale LED lighting installation beneath this expansive industrial canopy structure, completed under night conditions to minimise operational downtime. The high-bay LED fixtures provide powerful, uniform illumination across the entire covered area — essential for safe operations around the clock."
        },
        {
            id: 6,
            title: "EWSC: Delivering Excellence Through Precision Electrical Work",
            image: img6,
            date: "September 05",
            author: "Project Lead",
            category: "Electrical Installation",
            delay: "300",
            description: "In partnership with the Eswatini Water Services Corporation, we carried out full electrical wiring and feature lighting for their flagship office lobby. The elegant architectural lighting highlights the space's distinctive design elements, reflecting the organisation's commitment to excellence — captured perfectly in their motto: #WeDoItThroughOurPeople."
        }
    ];

    return (
        <section id="recent-posts" className="recent-posts section py-16 relative">
            <div className="absolute top-6 right-6 z-10">
                <img src={Logo} alt="Alternative Energy" className="h-10 w-auto md:h-14 opacity-80" />
            </div>
            <div className="container mx-auto px-4 section-title" data-aos="fade-up">
                <h2 className="text-4xl font-bold text-center mb-4">Recent Projects Insights</h2>
                <div className="flex justify-center mb-4">
                    <div className="h-1 w-16 rounded-full" style={{ background: 'var(--accent-color)' }} />
                    <div className="h-1 w-6 rounded-full mx-1 opacity-40" style={{ background: 'var(--accent-color)' }} />
                    <div className="h-1 w-3 rounded-full opacity-20" style={{ background: 'var(--accent-color)' }} />
                </div>
                <p className="text-xl text-center text-gray-600 mb-12">
                    Latest Updates On Our Recent Projects
                </p>
            </div>

            <div className="container mx-auto px-4">
                <div className="flex flex-wrap -mx-4">
                    {posts.map((post) => (
                        <div key={post.id} className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                            <div className="post-item relative h-full bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-lg overflow-hidden"
                                data-aos="fade-up" data-aos-delay={post.delay}>

                                <div className="post-img relative overflow-hidden">
                                    <img
                                        src={post.image}
                                        className="w-full h-64 object-cover transition-transform duration-500 hover:scale-110"
                                        alt={post.title}
                                    />
                                    <span className="post-date absolute bottom-0 right-0 bg-green-600 text-white text-sm font-medium px-3 py-2">
                                        {post.date}
                                    </span>
                                </div>

                                <div className="post-content flex flex-col p-6">
                                    <h3 className="post-title text-xl font-bold text-gray-800 mb-3 line-clamp-2">
                                        {post.title}
                                    </h3>

                                    <div className="meta flex items-center text-sm text-gray-600 mb-4">
                                        <div className="flex items-center">
                                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                            </svg>
                                            <span className="ml-1">{post.author}</span>
                                        </div>
                                        <span className="px-3 text-gray-400">/</span>
                                        <div className="flex items-center">
                                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z" clipRule="evenodd" />
                                            </svg>
                                            <span className="ml-1">{post.category}</span>
                                        </div>
                                    </div>

                                    <p className="text-sm text-gray-600 leading-relaxed">
                                        {post.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RecentPosts;